export default __webpack_public_path__ + "static/media/IC00023-wallet_org.eaf49032.svg";